import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const AUTH_STATUS = {
  CHECKING: 'checking',
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
};

// Phase 4: Single auth state source for guards and pages.
export const useAuthStore = create(
  devtools(
    (set) => ({
      status: AUTH_STATUS.CHECKING,
      accessToken: null,
      refreshToken: null,
      email: null,
      locationId: null,
      setChecking: () => set({ status: AUTH_STATUS.CHECKING }, false, 'auth/setChecking'),
      setAuthenticated: (payload) =>
        set(
          {
            status: AUTH_STATUS.AUTHENTICATED,
            accessToken: payload?.accessToken || null,
            refreshToken: payload?.refreshToken || null,
            email: payload?.email || null,
            locationId: payload?.locationId || null,
          },
          false,
          'auth/setAuthenticated'
        ),
      setUnauthenticated: () =>
        set(
          {
            status: AUTH_STATUS.UNAUTHENTICATED,
            accessToken: null,
            refreshToken: null,
            email: null,
            locationId: null,
          },
          false,
          'auth/setUnauthenticated'
        ),
    }),
    { name: 'auth-store' }
  )
);
